module.exports = __webpack_public_path__ + "static/media/wave-2.c2a3d2c1.svg";